module.exports = __webpack_public_path__ + "img/teaching_9.3d86d935.png";